/* eslint-disable arrow-body-style */
import gsap from 'gsap';

const poiHolographicConsole = {
  schema: {
  },

  init() {
    this.el.addEventListener('click', () => {
      if (this.alreadyInteracted || this.el.poiIsLocked) return;
      // this.alreadyInteracted = true;
      this.el.sceneEl.emit('showMessage', {
        title: 'Console',
        message: /*`
        Ship Status: Imminent collision with planet.<br/>
        Escape Pods Status: 0 of 10 available.<br/>
        Prepare for impact.
        `*/
        /*`Ship Status: All systems nominal
        Approaching the planet`,*/
        [
          "holographic_console_1",
          "holographic_console_2",
          "holographic_console_3",
          "holographic_console_4",
          "holographic_console_5"
        ],
        callback: () => {
          this.playAnimation();
          window.uiManager.showCta(true);
          setTimeout(() => {
            window.gameManager.setRaycastEnabled(false);
          }, 100);
        }
      }, false);
    });
  },

  playAnimation() {
    /*gsap.to(this.el.object3D.position, {
      duration: 1.0,
      z: '+=4.2',
      ease: 'sine.inOut',
    });*/
  },
};

export default poiHolographicConsole;
